import './App.css';
import WeatherApp from './Components/WeatherApp/WeatherApp';

function App() {
  return (
    <div className="App">
      <WeatherApp/>
      
    </div>
  );
}

export default App;
